module.exports = "/shifts/components/shiftBoxMiniIcons-378ecc.html";